import { DateValue, parseAbsolute } from '@internationalized/date';
import { useMemo } from 'react';

export const useInternationalizedToJsDate = ({ date, timezone }: { date: Date; timezone: string }) => {
  const internationalizedDate = useMemo<DateValue>(() => parseAbsolute(date.toISOString(), timezone), [date, timezone]);

  return { internationalizedDate };
};
